module.exports = __webpack_public_path__ + "static/image1-5e1002cbe6d4c1961cc2e644464e9b5e.jpg";